<template>
	<AmeliproAccordionResultTemplate
		:border-color="borderColor"
		:bordered="bordered"
		:card-color="cardColor"
		:is-open="opened"
		:unique-id="uniqueId"
		@open-close="openClose"
	>
		<template #headingContent>
			<slot name="headingContent" />
		</template>

		<template #default>
			<slot name="accordionContent" />
		</template>
	</AmeliproAccordionResultTemplate>
</template>

<script setup lang="ts">
	import AmeliproAccordionResultTemplate from '../AmeliproAccordionResultTemplate/AmeliproAccordionResultTemplate.vue';
	import { ref } from 'vue';

	const props = defineProps({
		borderColor: {
			type: String,
			default: 'ap-grey lighten-2',
		},
		bordered: {
			type: Boolean,
			default: true,
		},
		cardColor: {
			type: String,
			default: 'ap-white',
		},
		isOpen: {
			type: Boolean,
			default: false,
		},
		uniqueId: {
			type: String,
			required: true,
		},
	});

	const opened = ref(props.isOpen);

	const openClose = (): void => {
		opened.value = !opened.value;
	};

	// Rendre publique la méthode openClose permet à un bouton ou à un composant externe de fermer/ouvrir l'accordéon
	defineExpose({ openClose });
</script>

